import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import { Route, Routes } from "react-router-dom";
import List from "./List";
import { useAuthorization } from "../../../common/providers/AuthorizationProvider";
import "./style.css";

const ClientsMspa = (): JSX.Element => {
  const authorized = useAuthorization();
  if (!authorized) {
    return <ScopeStackSpinner />;
  }

  return (
    <Routes>
      <Route path="/" element={<List />} />
    </Routes>
  );
};

export default ClientsMspa;
